<calao-settings-group icon="barcode" title="Lecteur">
	@if(barcodeReaderModeParamsSignal(); as params) {
	<calao-setting-select [label]="params.label" [values]="params.values" [defaultValue]="params.defaultValue"
		(onChange)="raiseAccurancyChanged($event)" [disabled]="true">
	</calao-setting-select>
	}
</calao-settings-group>

@if(disableDeliveriesTutorialParamsSignal(); as params) {
<calao-settings-group icon="delivery-bold" title="Livraisons">
	<calao-setting-toggle [params]="params" (onValueChanged)="raiseDisableDeliveriesTutorial($event)">
	</calao-setting-toggle>
</calao-settings-group>
}